/**
 * prompt_engineer/conversationApi.js — Sprint 1 refactor (2026-05-20)
 *
 * Trước: REACT_APP_OPENAI_KEY + user_token + /stream/chatgpt(/free).
 * Sau:   gateway POST /api/v1/llm-gateway/chat/stream với JWT, tool='prompt_engineer'.
 *
 * Backend routing → Claude Sonnet 4.6 (quality cho prompt workbench).
 */

import { store } from 'store';
import apiSlice from 'store/slices/apiSlice';
import { streamChatLegacy, RateLimitError } from '../_shared/llmGateway';

const TOOL = 'prompt_engineer';

const PE_SYSTEM_PROMPT =
    'You are a senior prompt engineer. When the user submits a draft prompt, refine it for clarity, specificity, and structure. ' +
    'Return the improved prompt plus 2-3 bullets explaining the changes.';

/**
 * Streaming prompt-engineer chat via gateway. Chữ ký cũ:
 *   fetchAnswerSteaming(question, model, apiKey, selectedDocs, history, conversationId, project, onEvent)
 */
export function fetchAnswerSteaming(
    question,
    model,
    _apiKey,
    _selectedDocs,
    history = [],
    _conversationId,
    _project,
    onEvent,
    opts = {}
) {
    return streamChatLegacy({
        tool: TOOL,
        question,
        history,
        model,
        systemPrompt: opts.systemPrompt || PE_SYSTEM_PROMPT,
        signal: opts.signal,
        onEvent,
    }).catch((e) => {
        if (e instanceof RateLimitError) {
            onEvent?.(new MessageEvent('message', { data: JSON.stringify({ type: 'error', detail: e.message, tool: TOOL, status: 429 }) }));
        }
        throw e;
    });
}

export async function sendFeedback(prompt, response, feedback) {
    const res = await store.dispatch(
        apiSlice.endpoints.postChatFeedback.initiate({
            question: prompt,
            answer: response,
            feedback,
            project: TOOL,
        })
    );
    if (res?.data !== undefined || res?.isSuccess) return Promise.resolve();
    return Promise.reject(new Error('sendFeedback failed'));
}
